export default "__VITE_ASSET__d7d1bcef__"